// extracted by mini-css-extract-plugin
export var phone = "_2a-0";
export var phoneDragging = "_2a-1";